module.exports = __webpack_public_path__ + "img/dis-xiaoyuandian.fea0e52a.svg";